<!-- [コンテンツ領域] -->
<div class="l-core-contents">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-core-contents__inner l-core-contents__inner--full l-core-contents__inner--bt-0">
        <!-- [コンテンツ領域フルカラム−メイン] -->
        <div class="l-core-contents__main">
          <div class="l-section">
            <div class="p-result-function">
              <div class="p-result-function__block">
                <div class="p-result-function__item">
                  <asw-cabin-class
                    [complexRequest]="this.complexRequest"
                    [flightType]="this.flightType"
                    (clickCabinClassEvent)="openCabinClassModal($event)"
                  ></asw-cabin-class>
                </div>
                <div class="p-result-function__item">
                  <asw-fare-option
                    [complexRequest]="this.complexRequest"
                    [flightType]="this.flightType"
                    (clickFareOptionTypeEvent)="openFareOptionTypeModal($event)"
                  ></asw-fare-option>
                </div>
              </div>
              <div *ngIf="isPc" class="p-result-function__block">
                <div class="p-result-function__item">
                  <asw-add-to-favorite [isPc]="isPc"></asw-add-to-favorite>
                </div>
              </div>
            </div>
          </div>

          <div class="l-section u-mt-pc-32">
            <div class="c-passenger-display">
              <span class="c-passenger-display__passenger">
                {{ this.travelersLabel }}
              </span>
            </div>
          </div>

          <div class="l-section u-mt-tb-16 u-mt-sp-16">
            <div class="p-fare-title">
              <h2 class="p-fare-title__title">{{ 'm_static_message-lebel.fareSelection' | staticMsg }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- [運賃選択] -->
<asw-fare-panel-select
  [flightType]="this.flightType"
  [complexFlightAvailability]="this.complexFlightAvailability"
  [currentIndex]="this.selectedFFIndex"
  (returnToSelectStatus)="setTargetBounds($event)"
></asw-fare-panel-select>

<div class="l-core-contents">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-core-contents__inner l-core-contents__inner--full">
        <!-- [コンテンツ領域フルカラム−メイン] -->
        <div class="l-core-contents__main">
          <!-- [travel-summary表示] -->
          <asw-travel-summary
            [numberOfConnections]="this.numberOfConnections"
            [duration]="this.duration"
            [accrualMiles]="this.accrualMiles ?? 0"
            [isMilesDisplay]="this.isMilesDisplay"
          >
          </asw-travel-summary>

          <!-- [flight-bound表示] -->
          <asw-flight-bound
            [complexResponse]="this.complexFlightAvailability"
            [fareFamily]="this.fareFamily ?? {}"
            [cabin]="cabinClass || ''"
            [isPc]="isPc"
            (clickFlightDetailEvent)="this.openFlightDetailModal($event)"
          ></asw-flight-bound>
          <!-- [flight-bound表示] -->

          <!-- [タイムスタンプ表示] -->
          <div class="l-section">
            <div class="p-date-display01">
              <div class="p-date-display01__time">{{ searchedDateTime | dateFormat : 'default_currentDate' }}</div>
            </div>
          </div>
        </div>
        <!-- [コンテンツ領域フルカラム−メイン] -->
      </div>
    </div>
  </div>
</div>
<!--[コンテンツ領域] -->

<!-- [画面下部固定フローティングナビ] -->
<asw-footer
  *ngIf="this.isShowFooter"
  [fareFamily]="this.fareFamily ?? {}"
  [isPc]="isPc"
  [isMilesDisplay]="this.isMilesDisplay"
  [travelers]="this.travelers"
></asw-footer>
<!-- [画面下部固定フローティングナビ] -->
